var _circle, _circle2, _circle3, _circle4, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconIfblock = function SvgIconIfblock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 2.643,
    r: 1.286,
    stroke: "#A4A7AD"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11.214,
    r: 1.286,
    stroke: "#A4A7AD"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.714,
    cy: 11.214,
    r: 1.286,
    stroke: "#A4A7AD"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.286,
    cy: 11.214,
    r: 1.286,
    stroke: "#A4A7AD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4A7AD",
    d: "M7.071 3.929v6M7.429 6.5H4.286a2 2 0 0 0-2 2V9.93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.571 6.5h3.143a2 2 0 0 1 2 2V9.93",
    stroke: "#A4A7AD"
  })));
};
export default SvgIconIfblock;